import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
async function getMainSupervisor(driverList) {
  const criteria = {
    filters: [
      'id',
      'key',
      'name',
      'login',
      'organization.id',
      'enabled',
      'restrictDrivers',
      'mainSupervisor.*',
      'mainSupervisor.login'
    ]
  };

  const payload = {
    criteriaChain: [
      {
        or: driverList.map((id) => ({ attr: 'id', eq: id.toString() }))
      }
    ]
  };

  const url = `/Driver/restrictions?criteria=${encodeURI(
    JSON.stringify(criteria)
  )}`;
  const response = await defaultFetch(url, payload, 'POST');
  if (response.error) {
    return Promise.reject(new Error(JSON.stringify(response)));
  }
  return response;
}
export function useMainSupervisor(driverList) {
  const ONE_MINUTE = 1000 * 60;
  return useQuery({
    queryKey: ['drivers', driverList],
    staleTime: ONE_MINUTE,
    queryFn: async () => {
      if (driverList) {
        return getMainSupervisor(driverList);
      }
      return [];
    }
  });
}
